import {
    List,
    Datagrid,
    TextField,
    BooleanField,
    FilterList,
    Pagination,
    ShowButton
} from "react-admin"

import { Card, CardContent, Grid, Paper } from "@mui/material"
import StatusField from "CustomFields/StatusField"
import DynamicFilterListItem from "CustomElements/DynamicFilterListItem"

const FilterSidebar = () => (
    <Paper elevation={20}>
        <Card>
            <CardContent>
                <FilterList label="Mediacat Yayınlanma Durumu" icon={<></>}>
                    <DynamicFilterListItem
                        label="Yayınlanıyor"
                        name="isMediaCatAllowed"
                        val={true}
                    />
                    <DynamicFilterListItem
                        label="Yayınlanmıyor"
                        name="isMediaCatAllowed"
                        val={false}
                    />
                </FilterList>
            </CardContent>
        </Card>
    </Paper>
)

const DataList = () => {
    return (
        <>
            <Datagrid bulkActionButtons={false}>
                <TextField source="name" />
                <TextField source="slug" />
                <BooleanField
                    source="isMediaCatAllowed"
                    label="MediaCat Durumu"
                />
                <StatusField source="status" label="Yayın Durumu" />
                <ShowButton label="Göster" />
            </Datagrid>
            <Pagination rowsPerPageOptions={[5, 10, 25]} />
        </>
    )
}

export const FeatureCategoryList = () => (
    <List
        hasShow
        pagination={<></>}
        sort={{
            field: "createDate",
            order: "DESC"
        }}>
        <Grid container spacing={2}>
            <Grid item xs={2}>
                <FilterSidebar />
            </Grid>
            <Grid item xs={10}>
                <DataList />
            </Grid>
        </Grid>
    </List>
)
